import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/userPolicy',
    name: 'userPolicy',
    component: () => import('./views/UserPolicy.vue'),
    meta: { title: '用户协议', keepAlive: false, auth: false }
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('./views/PrivacyPolicy.vue'),
    meta: { title: '隐私协议', keepAlive: false, auth: false }
  },
  {
    path: '/realNamePolicy',
    name: 'realNamePolicy',
    component: () => import('./views/RealNamePolicy.vue'),
    meta: { title: '实名认证协议', keepAlive: false, auth: false }
  },
  {
    path: '*',
    redirect: {
      name: 'userPolicy'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',// 'history',
  routes,
  scrollBehavior: () => ({ y: 0 })
})

export default router
